const styles = theme => ({
  container: {
    padding: '25px',
  },
  containerPad: {
    padding: '0px 25px 25px',
  },
  textAr: {
    fontFamily: '"madani", sans-serif',
    lineHeight: '18px',
  },
  flex: {
    display: 'flex',
    gap: '10px',
  },
  hrColor: {
    border: '0.5px solid #CED1D6',
    margin: '0px',
  },
  ownerAvatarimg: {
    width: '60px',
    height: '60px',
  },
  viewDetail: {
    borderRadius: '10px',
    background: '#F8F8F8',
    padding: '15px',
    marginTop: '20px',
  },
  marginTop: { marginTop: '15px' },
  titleImage: { maxWidth: '100%' },
  marginBottom: {
    marginBottom: '24px',
    border: `1px solid ${theme.palette.secondary.disableLightGray}`,
  },
  titleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    display: 'flex',

    padding: '10px 16px',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      borderBottom: '1px solid #CED1D6',
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '16px',
      fontWeight: '600',
    },
  },
  title: {
    fontWeight: '600',
    marginBottom: '5px',
    fontSize: '16px',
    display: 'flex',
    width: '100%',
  },
  textDanger: {
    color: theme.palette.primary.main,
  },
  initiateserviceSect: {
    marginBottom: '16px',
  },
  initiateservicedtaile: {
    display: 'grid',
    gridTemplateColumns: 'auto',
    gap: '9px',
    position: 'relative',
    '& $titleImage': {
      display: 'block',
      width: '100%',
      height: 'auto',
      borderRadius: '10px',
    },
    '& $textHolder': {
      [theme.breakpoints.down('sm')]: {
        padding: '0 15px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      gap: '15px',
    },
  },
  darkgreen: {
    color: '#fff',
    background: '#1C999B',
  },
  initibadges: {
    marginLeft: '5px',
  },
  ownerShipType: {
    color: theme.palette.primary.adgmInfo,
    border: `1px solid ${theme.palette.primary.adgmInfo}`,
    background: theme.palette.primary.infoBlueLight,
  },
  strongText: {
    fontSize: '14px',
    fontWeight: '600',
    marginTop: '5px',
    marginBottom: '10px',
  },
  dangerLight: {
    color: '#B9350B',
    background: '#FDF0ED',
  },
  warning: {
    color: theme.palette.primary.warningMango,
    border: `1px solid ${theme.palette.primary.warningMango}`,
    background: theme.palette.primary.warningMangoLight,
  },
  error: {
    color: theme.palette.primary.dangerRed,
    border: `1px solid ${theme.palette.primary.dangerRed}`,
    background: theme.palette.primary.dangerRedLight,
  },
  dim: {
    color: theme.palette.primary.darkgray,
    border: `1px solid ${theme.palette.primary.darkgray}`,
    background: theme.palette.primary.borderColor,
  },
  divider: {
    border: '4px solid #EBEEF3',
  },
  viewmoreHolder: {
    borderTop: '1px solid #EBEEF3',
    padding: '16px 10px',
    textAlign: 'center',
    cursor: 'pointer',
    color: '#1C999B',

    '& a': {
      color: '#1C999B',
    },
  },
  redColor: {
    color: '#D2374F',
  },
  adgmSelect: {
    maxWidth: '350px',
  },
  viewOnMap: {
    marginLeft: '20px',
    marginTop: '25px',
  },
  linkBtn: {
    color: '#096BCE',
    fontWeight: '500',
    fontSize: '16px',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  flexArea: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '25px',
  },
  flexAreaADGM: {
    paddingTop: '25px',
  },
  viewDetailInfoMain: {
    width: '100%',
    marginTop: '20px',
  },
  viewDetailInfo: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '13px',
    '& a': {
      color: '#1270B4',
      fontWeight: '500',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  },
  '@media (min-width: 768px)': {
    titleHead: {
      padding: '16px 24px',
      '& h1': {
        fontSize: '20px',
      },
    },
    title: {
      fontSize: '20px',
    },
  },
  '@media (max-width: 767px)': {
    titleHead: {
      flexWrap: 'wrap',
    },
  },
  '@media (min-width: 960px)': {
    initiateservicedtaile: {
      gridTemplateColumns: '61px auto',
    },
    Title: {
      fontSize: '1.25rem',
    },
    strongText: {
      fontSize: '18px',
    },
  },
});
export default styles;
